<form class="container" [class.hide-preview]="!pdfSrc">
  <div class="left-side-wrapper">
    <div class="scrollable-content">
      <h1>Lernkarten erfolgreich erstellt</h1>

      <app-radio-widget-selection *ngIf="deviceSize !== 'mobile'" [label]="'Wie viele Lernkarten möchtest du erstellen?'" [options]="quantityOptions" [(selectedOption)]="selQuantityOption" (selectedOptionChange)="filterFlashcards()"></app-radio-widget-selection>

      <div *ngIf="filteredPages && filteredPages.length > 0" class="flashcard-list">
        <div class="file-page-container" *ngFor="let page of filteredPages; let index = index" #filePageContainer>
          <div class="page-header">
            <span>Seite {{ index + 1 }}</span>
            <span *ngIf="page">{{ page.length }} Lernkarten</span>
          </div>
          <ng-container *ngIf="page && page.length > 0">
            <app-flashcard-widget *ngFor="let flashcard of page" [flashcard]="flashcard" [hideEdit]="true" (actionClicked)="handleFlashcardAction(page, flashcard, $event)"></app-flashcard-widget>
          </ng-container>
          <div *ngIf="!page || page.length === 0" class="empty-container">Für diese Seite wurden keine Lernkarten erstellt.</div>
        </div>
      </div>
    </div>

    <div class="buttons-container" [class.is-demo]="isDemo">
      <div class="total-count">
        <i-tabler name="cards"></i-tabler>{{totalCount}} Lernkarten
      </div>
      <div class="buttons">
        <app-button [text]="'misc.back' | translate" (clickEvent)="goBack()" [style]="'outlined'"></app-button>
        <app-button [text]="isDemo ? 'Lernkarten speichern' : 'Alle übernehmen'" (clickEvent)="saveFlashcards()" [loading]="isLoading"></app-button>
      </div>
    </div>
  </div>

  <div class="pdf-container" *ngIf="deviceSize !== 'mobile' && pdfSrc">
    <pdf-viewer
      [src]="pdfSrc"
      [render-text]="true"
      [show-all]="true"
      [(page)]="currentPage"
      [fit-to-page]="true"
    ></pdf-viewer>

    <div class="pdf-footer">
      <i-tabler name="circle-arrow-left" (click)="previousPage()"></i-tabler>
      <span>{{currentPage}} / {{pdfPagesCount}}</span>
      <i-tabler name="circle-arrow-right" (click)="nextPage()"></i-tabler>
    </div>
  </div>
</form>